import React, { useState } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

const ContentModal = ({ initiallyOpen, children, buttonLabel, className = '', onOkClicked }) => {
    const [open, setOpen] = useState(initiallyOpen);
  
    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);
    const handleOkClicked = () => {
      onCloseModal();
      onOkClicked && onOkClicked();
    };
  
    return (
      <div>
        {!initiallyOpen && (
          <button className='modal-btn' onClick={onOpenModal}>
            {buttonLabel}
          </button>
        )}
        <Modal open={open} onClose={onCloseModal} center showCloseIcon={false}>
          <div className={`modal-wrap ${className}`}>
            {!initiallyOpen && (
              <div className="btn-wrap" onClick={onCloseModal}>
                <button className="btn-close" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" fill="#212D5E" />
                <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" fill="#212D5E" />
                <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" fill="#212D5E" />
                <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" stroke="#212D5E" />
                <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" fill="#212D5E" />
                <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" fill="#212D5E" />
                <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" fill="#212D5E" />
                <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" stroke="#212D5E" />
              </svg>
                </button>
              </div>
            )}
            <div className='modal-content'>
              {children}
            </div>
            {initiallyOpen && (
              <div className='modal-action'>
                <button className='btn btn-primary' onClick={handleOkClicked}>OK</button>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  };
  
  export default ContentModal;